// Tema tampilan — DAFTAR (registry) tema yang bisa dipilih pengguna & mudah ditambah nanti.
// Menambah tema = tambah satu objek di THEMES (tak perlu sentuh CSS). Nilai tema = override token
// di theme.css; 'terang' = kosong (pakai nilai bawaan :root). Diterapkan lewat CSS custom property
// di <html> + disimpan per perangkat (localStorage). Default = ikut preferensi sistem.
const KEY = 'ifics_theme';

export interface ThemeDef {
  id: string;
  nama: string;
  /** 3 warna contekan untuk pratinjau di pemilih: [latar, permukaan, aksen]. */
  swatch: [string, string, string];
  /** Override token thd :root bawaan (terang). Kosong = pakai bawaan. */
  vars: Record<string, string>;
}

export const THEMES: ThemeDef[] = [
  { id: 'terang', nama: '☀️ Terang', swatch: ['#f4f7fa', '#ffffff', '#0A2A4A'], vars: {} },
  { id: 'gelap', nama: '🌙 Gelap', swatch: ['#0e1620', '#17222e', '#8ecbf0'], vars: {
    '--backdrop': 'rgba(0,0,0,.8)', '--bg': '#0e1620', '--surface': '#17222e', '--surface2': '#1c2834', '--hairline': '#243140',
    '--line': '#2b3947', '--txt': '#e6edf3', '--muted': '#93a4b3', '--navy': '#8ecbf0', '--navy2': '#6fb6e0',
    '--ice': '#1e2b38', '--okbg': '#123329', '--warnbg': '#3a2e12', '--dangerbg': '#3a1f1c', '--fill': '#24557d', '--fill2': '#2f6f9e',
    '--ok': '#3fca9a', '--warn': '#e8b24a', '--danger': '#f0857a' } }, // aksen dicerahkan agar teks terbaca di gelap (WCAG)
  { id: 'midnight', nama: '🌌 Midnight Biru', swatch: ['#0b1220', '#141d31', '#7cc0ff'], vars: {
    '--backdrop': 'rgba(0,0,0,.8)', '--bg': '#0b1220', '--surface': '#141d31', '--surface2': '#1a2540', '--hairline': '#26314d',
    '--line': '#2c3a5c', '--txt': '#e9eefb', '--muted': '#94a3c4', '--navy': '#7cc0ff', '--navy2': '#5aa9f0',
    '--ice': '#1c2848', '--okbg': '#123a2e', '--warnbg': '#3d3115', '--dangerbg': '#3f2020', '--fill': '#2b5aa6', '--fill2': '#356fc8',
    '--ok': '#40cf9d', '--warn': '#eab54e', '--danger': '#f2897d' } },
  { id: 'slate', nama: '🪨 Slate', swatch: ['#14181d', '#1e242b', '#9fd3ea'], vars: {
    '--backdrop': 'rgba(0,0,0,.8)', '--bg': '#14181d', '--surface': '#1e242b', '--surface2': '#242b33', '--hairline': '#2e363f',
    '--line': '#333c46', '--txt': '#e7ebef', '--muted': '#96a2ad', '--navy': '#9fd3ea', '--navy2': '#7fbfdd',
    '--ice': '#242c34', '--okbg': '#183028', '--warnbg': '#352c16', '--dangerbg': '#38211f', '--fill': '#3a4c5e', '--fill2': '#4a6076',
    '--ok': '#3fca9a', '--warn': '#e8b24a', '--danger': '#f0857a' } },
  { id: 'nord', nama: '❄️ Nord', swatch: ['#2e3440', '#3b4252', '#88c0d0'], vars: {
    '--backdrop': 'rgba(0,0,0,.8)', '--bg': '#2e3440', '--surface': '#3b4252', '--surface2': '#434c5e', '--hairline': '#3f495a',
    '--line': '#4c566a', '--txt': '#eceff4', '--muted': '#9aa5ba', '--navy': '#88c0d0', '--navy2': '#8fbcbb',
    '--ice': '#434c5e', '--okbg': '#33403a', '--warnbg': '#40392a', '--dangerbg': '#43333a', '--fill': '#5e81ac', '--fill2': '#6f92bd',
    '--ok': '#a3be8c', '--warn': '#ebcb8b', '--danger': '#e0868f' } },
  { id: 'dracula', nama: '🧛 Dracula', swatch: ['#282a36', '#343746', '#bd93f9'], vars: {
    '--backdrop': 'rgba(0,0,0,.8)', '--bg': '#282a36', '--surface': '#343746', '--surface2': '#3c3f52', '--hairline': '#3a3d4d',
    '--line': '#44475a', '--txt': '#f8f8f2', '--muted': '#a5a7bd', '--navy': '#bd93f9', '--navy2': '#caa9fa',
    '--ice': '#3c3f52', '--okbg': '#1f3a2e', '--warnbg': '#3f3620', '--dangerbg': '#3f2531', '--fill': '#6272a4', '--fill2': '#7385bd',
    '--ok': '#50fa7b', '--warn': '#f1fa8c', '--danger': '#ff6e6e' } },
  { id: 'emerald', nama: '🌿 Emerald', swatch: ['#0e1a15', '#16261f', '#4ade9e'], vars: {
    '--backdrop': 'rgba(0,0,0,.8)', '--bg': '#0e1a15', '--surface': '#16261f', '--surface2': '#1b2f26', '--hairline': '#24382e',
    '--line': '#2b463a', '--txt': '#e4f0ea', '--muted': '#93b0a4', '--navy': '#4ade9e', '--navy2': '#34c88c',
    '--ice': '#1b2f26', '--okbg': '#123a2b', '--warnbg': '#38321a', '--dangerbg': '#3a2020', '--fill': '#1f7a56', '--fill2': '#268a63',
    '--ok': '#4ade9e', '--warn': '#e8b24a', '--danger': '#f0857a' } },
  { id: 'sepia', nama: '📜 Sepia', swatch: ['#f3ead5', '#fbf5e6', '#7a5a2a'], vars: {
    '--backdrop': 'rgba(10,42,74,.45)', '--bg': '#f3ead5', '--surface': '#fbf5e6', '--surface2': '#f6eeda', '--hairline': '#e6dcc4',
    '--line': '#d9cbac', '--txt': '#43371f', '--muted': '#8a7a58', '--navy': '#7a5a2a', '--navy2': '#6a4c22',
    '--ice': '#efe4cb', '--okbg': '#e6f0dd', '--warnbg': '#f6eccf', '--dangerbg': '#f6ddd4', '--fill': '#7a5a2a', '--fill2': '#6a4c22',
    '--ok': '#4a7a3a', '--warn': '#a8791a', '--danger': '#b04a2a' } },
];

/** Semua token yang mungkin di-set tema mana pun — untuk dibersihkan saat pindah tema. */
export const ALL_THEME_TOKENS: string[] = [...new Set(THEMES.flatMap((t) => Object.keys(t.vars)))];

export function themeById(id: string | null | undefined): ThemeDef {
  return THEMES.find((t) => t.id === id) ?? THEMES[0]!;
}

/** Terapkan token tema ke <html> (tanpa menyimpan). Bersihkan token tema lama dulu. */
function applyVars(t: ThemeDef): void {
  const s = document.documentElement.style;
  for (const tok of ALL_THEME_TOKENS) s.removeProperty(tok);
  for (const [k, v] of Object.entries(t.vars)) s.setProperty(k, v);
  document.documentElement.dataset['theme'] = t.id;
}

/** Id tema aktif: pilihan tersimpan; kalau belum ada → ikut preferensi sistem (gelap/terang). */
export function currentThemeId(): string {
  let saved: string | null = null;
  try { saved = localStorage.getItem(KEY); } catch { /* diblok → pakai sistem */ }
  if (saved === 'dark') return 'gelap'; if (saved === 'light') return 'terang'; // kompat nilai lama
  if (saved && THEMES.some((t) => t.id === saved)) return saved;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'gelap' : 'terang';
}

/** Pilih tema: terapkan + simpan (per perangkat). */
export function setTheme(id: string): void {
  const t = themeById(id);
  applyVars(t);
  try { localStorage.setItem(KEY, t.id); } catch { /* diblok → berlaku sesi ini saja */ }
}

/** Panggil sekali saat boot (sebelum render) supaya tak ada kedip terang→gelap. */
export function initTheme(): void {
  applyVars(themeById(currentThemeId()));
}
